const EUROPEAN_UNION_COUNTRIES = [
	'AT',
	'BE',
	'BG',
	'CY',
	'CZ',
	'DE',
	'DK',
	'EE',
	'ES',
	'FI',
	'FR',
	'GB',
	'GR',
	'HR',
	'HU',
	'IE',
	'IT',
	'LV',
	'LT',
	'LU',
	'MT',
	'NL',
	'PL',
	'PT',
	'RE',
	'RO',
	'SE',
	'SI',
	'SK',
];



export default function isCountryInEuropeanUnion(country: string) {
	return EUROPEAN_UNION_COUNTRIES.includes(country);
}
